import { SvgIcon, SvgIconProps } from '@mui/material'

const KeyboardArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 20 20" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6.64143 4.55806C6.39735 4.80214 6.39735 5.19786 6.64143 5.44194L11.1995 10L6.64143 14.5581C6.39735 14.8021 6.39735 15.1979 6.64143 15.4419C6.88551 15.686 7.28124 15.686 7.52532 15.4419L12.5253 10.4419C12.7694 10.1979 12.7694 9.80214 12.5253 9.55806L7.52532 4.55806C7.28124 4.31398 6.88551 4.31398 6.64143 4.55806Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default KeyboardArrowRight